import React, { useState } from "react";
import { Button, Modal, Input, Empty, Card, Image } from "antd";
import "./modals.scss";
import { SearchOutlined } from "@ant-design/icons";
import { useAppSelector, useAppDispatch } from "common/hooks/redux";
import { RootState } from "store/index";
import { toggleConnectWalletModal } from "store/global";
import { Connector, useConnect, useDisconnect, useAccount } from "wagmi";

type ConnectType = {
	data: {
		chain: string;
		logo: string;
	}[];
};

/**
 * @param {ConnectType} props
 */

const ConnectWalletModal: React.FC<ConnectType> = (
	props: ConnectType
): React.ReactElement => {
	const { data } = props;
	// const [isConnected, setIsConnected] = useState(false);
	const [searchText, setSearchText] = useState<string>("");
	const dispatch = useAppDispatch();
	const connectWalletModal = useAppSelector(
		(state: RootState) => state.global.connectWalletModal
	);
	const { connectors, connect } = useConnect();
	const { disconnect } = useDisconnect();
	const { isConnected } = useAccount();

	const hasMetaMask =
  typeof window !== "undefined" &&
  (window as any).ethereum &&
		(window as any).ethereum.isMetaMask;

	function toggleModal(visible: boolean = false) {
		dispatch(toggleConnectWalletModal(visible));
	}

	function disconnectWallet() {
		disconnect();
		toggleModal(false);
	}

	const onSearch = (e: any) => {
		setSearchText(e.target.value.toLowerCase());
	};

	const filteredConnectors = connectors.filter((connector) =>
		connector.name.toLowerCase().includes(searchText)
	);

	return (
		<Modal
			open={connectWalletModal}
			title="Connect your wallet"
			width="560px"
			wrapClassName="connect-wallet"
			footer={
				isConnected
					? [
						<Button key="back" onClick={() => toggleModal(false)}>
							Cancel
						</Button>,
						<Button type="primary" onClick={disconnectWallet}>
							Disconnect
						</Button>,
					]
					: []
			}
			onCancel={() => toggleModal(false)}
		>
			{
				<>
					<Input
						placeholder="Search…"
						onChange={onSearch}
						prefix={
							<SearchOutlined
								style={{
									fontSize: "16px",
									color: "#FFFFFF",
									marginRight: "5px",
								}}
							/>
						}
					/>
					<div>
						{!hasMetaMask ? (
							<div style={{ textAlign: "center", padding: "20px" }}>
							<p style={{ marginTop: "10px", color: "#fff", fontSize: "16px" }}>
								You need a Web3 wallet to continue. We recommend installing{" "}
								<a href="https://metamask.io/download/" target="_blank" rel="noopener noreferrer" style={{ color: "#c1fc49", fontWeight: "bold" }}>
									MetaMask
								</a>.
							</p>
						</div>
						) : filteredConnectors?.length > 0 ? (
							filteredConnectors.map(
								(connector) =>
									connector.icon && (
										<Card
											key={connector.uid}
											onClick={() => {
												connect({ connector });
												toggleModal(false);
											}}
											style={{ cursor: "pointer", textAlign: "center" }}
										>
											<Image
												src={connector.icon}
												preview={false}
												width="40px"
												height="40px"
											/>
											<p>{connector.name}</p>
										</Card>
									)
							)
						) : (
							<Empty description="No connectors match your search" />
						)}
					</div>
				</>
			}
		</Modal>
	);
};

export default ConnectWalletModal;
